import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="border-t border-gray-200 px-4 sm:px-6 py-10 sm:py-12 bg-gray-50">
      <div className="max-w-6xl mx-auto text-center text-gray-600 space-y-4 text-sm font-light">
        {/* Copyright */}
        <p className="text-xs sm:text-sm">{t('footer.copyright')}</p>

        {/* Links */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-gray-500 text-xs sm:text-sm">
          <a
            href="/statuts.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-gray-900 transition-colors"
          >
            {t('footer.statutes')}
          </a>
          <span className="hidden sm:block">•</span>
          <a
            href="mailto:contact@lesamisdeshalom.ch"
            className="hover:text-gray-900 transition-colors break-all sm:break-normal"
          >
            {t('footer.contact')}
          </a>
        </div>
      </div>
    </footer>
  );
}